import { z } from 'zod'
import { responseSchema } from '@/core/types/Response.ts'

export const baseQuoteSchema = z.object({
  paymentDate: z.string().nullable(),
  dueAt: z.string(),
  paid: z.string(),
  quote: z.string(),
  status: z.enum(['PENDIENTE', 'PAGADA', 'ATRASADA'])
})

export const quoteSchema = baseQuoteSchema.merge(
  z.object({
    quoteId: z.string(),
    creditId: z.string()
  })
)
export const extraQuoteSchema = quoteSchema.merge(
  z.object({
    type: z.enum(['PASSWORD_RECOVERY', 'PAY_SERVICE']),
    name: z.string()
  })
)
export const quotesSchema = z.array(quoteSchema)

export const quotesResponseSchema = responseSchema(quotesSchema)

export type quotesResponse = z.infer<typeof quotesResponseSchema>

export type Quote = z.infer<typeof quoteSchema>
export type ExtraQuote = z.infer<typeof extraQuoteSchema>
export type QuoteInternal = {
  quote: string
  date: string
  paymentDate: string | null
  fullPaid: boolean
  paid?: number
}

export const quoteDtoSchema = z.object({
  quote: z.string(),
  dueAt: z.string(),
  paid: z.number()
})

export type QuoteDto = z.infer<typeof quoteDtoSchema>
